import { DocumentFile } from './document.app';

export interface CategoryReport {
	id: number;
	description: string;
}

export interface ReportDocumentTemplate {
	id: number;
	htmlContent: string;
	validForTypeOfCareId?: number;
	category?: CategoryReport;
}

export interface ReportDocument {
	id: number;
	htmlContent: string;
	isFinal: boolean;
	isDraft: boolean;
	canBeSubmitted: boolean;
	createdAt: Date;
	updatedAt?: Date;
	template?: ReportDocumentTemplate;
	documents?: DocumentFile[];
	categoryReport: CategoryReport;
}

export enum REPORT_TYPE {
	UNKNOWN = 0,
	TECHNICAL_START_REPORT = 1,
	START_REPORT = 2,
	IMPEDIMENT_REPORT = 5,
	END_REPORT = 6,
	FDS = 12,
	ADMISSION_QB_REPORT = 98,
	END_QB_REPORT = 99,
}

export interface ReportDocumentUpdateBody {
	htmlContent: string;
	isFinal: boolean;
	isDraft: boolean;
	reportDocumentTemplateId: number | string;
	assignmentId: number | string;
	reportId: number | string;
}
